import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import PaymentMethodEntityModel from './model';

/**
 * @deprecated Use the rest graphql version of this `useFetchPaymentMethods`
 */
export const fetchPaymentMethods = (targetId: string, billPayerId?: string) => {
    return RESTClient.getAuthenticatedObservable(`v2/invoicing/${targetId}/paymentMethods`, {
        billPayerId,
    }).map(response => ({
        paymentMethods: List(response.paymentMethods).map(method => PaymentMethodEntityModel.fromAPI(method)),
    }));
};
